
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tapfiliate-alternative",
      function () {
        return require("private-next-pages/tapfiliate-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tapfiliate-alternative"])
      });
    }
  